export const DRAWER_HEADER = 'Delivery Details';
export const CHOOSE_OPTION_TEXT = 'Choose your delivery option in Checkout';
export const STH_DELIVERY = 'Estimated Delivery:';
export const BODFS_DELIVERY = 'Get it';
export const BODFS_DESC = 'Scheduled Delivery';
export const SHIP_TO_HOME = 'sth';
export const BUY_ONLINE_DELIVER_FROM_STORE = 'bodfs';
export const EXPRESS_DELIVERY = 'express delivery';
export const ERROR_MESSAGE = 'We’re experiencing technical difficulties. Please try again shortly.';
export const SIX_HOUR_CAR_BODFS_MESSAGE = 'Get it within 6 hours.';
export const CHOOSE_BODFS_MESSAGE = 'Choose Scheduled Delivery in checkout.';
// eslint-disable-next-line max-len
export const SCHEDULED_DELIVERY_MESSAGE = '*Select Scheduled Delivery in Checkout to schedule a day and time for your order to be delivered '
    + 'to an easily accessible area outside your home. Upgrade options available.';
export const TOMORROW_SCHEDULE_DELIVERY_TEXT = 'or schedule your delivery*';
export const SAME_DAY = 'same-day';
export const ON_DEMAND = 'on-demand';